import { values } from './_helpers'

const _enum = {
  bar: 0,
  machine: 1,
  shop: 2,
  eshop: 3,
  other: 4
}

const soldByChannel = { ..._enum, name: 'soldByChannel', values: values(_enum) }

export {
  soldByChannel
}
